import React from 'react'
import { useToasts } from 'react-toast-notifications'

import { Modal } from '@infura/packages.ui/Modal'

import ChargifyCCForm from 'components/billing/ChargifyCCForm'

import useUser from 'hooks/useUser'

type Props = {
  open: boolean
  onToggle: () => void
  title?: string
  message?: string
  hiddenCloseBtn?: boolean
  closeOnClickOutside?: boolean
}

export default function ChangePaymentModal({
  closeOnClickOutside = true,
  hiddenCloseBtn = false,
  message,
  onToggle,
  open,
  title
}: Readonly<Props>) {
  const { mutate: revalidateUser } = useUser()
  const { addToast } = useToasts()

  return (
    <Modal
      closeOnClickOutside={closeOnClickOutside}
      data-testid='change-payment-modal'
      heading={title}
      hiddenCloseBtn={hiddenCloseBtn}
      open={open}
      setIsOpen={() => {
        onToggle()
      }}
      width='xl'
    >
      {message ? <p className='text-primary text-left'>{message}</p> : null}
      <ChargifyCCForm
        onSuccess={() => {
          revalidateUser()
          onToggle()
          addToast('Payment method updated', {
            appearance: 'success',
            autoDismiss: true,
            autoDismissTimeout: 2000
          })
        }}
      />
    </Modal>
  )
}
